/*
 * @Author: louzhedong
 * @Date: 2021-03-22 11:03:21
 * @LastEditors: louzhedong
 * @LastEditTime: 2021-03-22 11:07:45
 * @Description: 描述一下咯
 */
import React from 'react';
import ReactDOM from 'react-dom';
import 'antd/dist/antd.less';
import './index.css';
import {RootRouter} from './routes/index';
import * as serviceWorker from './serviceWorker';
import { LocaleProvider } from 'antd';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import Tracker from 'xiaomai-web-sentry';
import User from '../src/core/user';


const Browser = Tracker.Browser;
const browser = new Browser();
const initParams = {
  project: 'xiaomai-web-facedetection',
  userId: User.uid(),
  env: process.env.DEPLOY_ENV || 'test'
};
browser.init(initParams);

const render = () => {
  ReactDOM.render(
    <LocaleProvider locale={zh_CN}>
      <RootRouter />
    </LocaleProvider>, document.getElementById('root'));
}

render()

serviceWorker.unregister();
